// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"407":"66eb1ba9","412":"5b912b64","482":"302c6a05","742":"e01c3b62","977":"fbd80d95"}[chunkId] + ".chunk.js";
};